<template>
    <tr v-if="value === null || value > 0" :class="additional_classes">
        <td :class="{ 'pl-8': indented }">
            {{ label }}
        </td>
        <td>
            {{ value ? this.$rc.pretty(this.value, 'int') : '' }}
        </td>
        <td class="text-center">
            <v-tooltip
                left
                v-if="description"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        mdi-information-outline
                    </v-icon>
                </template>

                <span>{{ description }}</span>
            </v-tooltip>
        </td>
    </tr>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: function() { return ""; },
        },
        value: {
            type: Number,
            default: function() { return null; },
            // null means no value, but still show the label
        },
        description: {
            type: String,
            default: null
        },
        indented: {
            type: Boolean,
            default: function() { return false; },
        },
        additional_classes: {
            type: String,
            default: function() { return null; }
        }
    },
    data() {
        return {
            show_description: false
        }
    }
}
</script>

<style lang="scss" scoped>
tr.row-total > td {
    border-style: solid none none none;
}
</style>